<template>
  <div class="category-create">
    <!-- 创建表单 -->
    <el-form ref="categoryForm" :model="formData" label-width="120px" label-position="right" size="medium">
      <!-- 客服编号 -->
      <el-form-item label="客服编号" prop="agent_no">
        <el-input style="width: 300px;" :disabled="!create" v-model="formData.agent_no" placeholder="请输入客服编号" clearable
          maxlength="10" show-word-limit />
      </el-form-item>
      <!-- 用户id -->
      <el-form-item label="用户id" prop="account_id">
        <el-input style="width: 300px;" v-model="formData.account_id" placeholder="请输入用户id" clearable maxlength="10"
          show-word-limit />
      </el-form-item>
      <!-- 客服wx_openid-->
      <el-form-item label="微信open_id" prop="wx_openid">
        <el-input style="width: 300px;" v-model="formData.wx_openid" placeholder="请输入客服微信wx_openid" clearable
          maxlength="20" show-word-limit />
      </el-form-item>
      <!-- 客服名称 -->
      <el-form-item label="客服昵称" prop="nick_name">
        <el-input style="width: 300px;" v-model="formData.nick_name" placeholder="请输入客服名称" clearable maxlength="20"
          show-word-limit />
      </el-form-item>
      <!-- 标准客服编号 -->
      <el-form-item label="服务优先级" prop="service_order">
        <el-input style="width: 300px;" v-model="formData.service_order" placeholder="请输入服务优先级" clearable
          show-word-limit />
      </el-form-item>
      <el-form-item label="客服邮箱" prop="e_mail">
        <el-input style="width: 300px;" v-model="formData.e_mail" placeholder="请输入客服邮箱" clearable show-word-limit />
      </el-form-item>

      <!-- 表单按钮 -->
      <el-form-item class="form-buttons">
        <el-button type="primary" @click="handleSubmit" :loading="submitting">
          {{ create ? '创建客服' : '保存修改' }}
        </el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button @click="handleCancel">取消</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { agenjtRegister, agentUpdate } from '@/api/onlines/shop.js';
export default {
  name: 'agentInfo',
  data() {
    // 自定义验证规则示例
    return {
      formData: {
        agent_no: "",
        account_id: "",
        nick_name: "",
        service_order: "",
        wx_openid: "",
        e_mail: ""
      },
      create: true,
      // 表单验证规则
      formRules: {
        agent_no: [
          { required: true, message: '请输入客服编号', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        agent_name: [
          { required: true, message: '请输入客服昵称', trigger: 'blur' }
        ]
      },
      // 提交状态
      submitting: false,
      // 成功对话框显示状态
      successDialogVisible: false,
      allPrimaryClassList: [],
      imageList: []
    }
  },

  created() {
  },
  mounted() {
  },
  methods: {
    /**
     * 父页面需要调用 修改客服信息时
     * @param d
     */
    setFormData(d) {
      this.formData = d;
      this.create = false;
    },
    /**
     * 获取所有线上客服
     */
    /* async getClassifyList() {
      this.allPrimaryClassList = [];
      this.classTreeList = [];
      const res = await getClassifyList();
      this.allPrimaryClassList = res.allList;
      this.classTreeList = res.t2;
    }, */
    /**
     * 提交表单
     */
    handleSubmit() {
      const that = this;
      this.$refs.categoryForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true;
          try {
            const data = {
              account_id: this.formData.account_id,
              nick_name: this.formData.nick_name,
              service_order: String(this.formData.service_order),
              e_mail: this.formData.e_mail,
              agent_no: this.formData.agent_no,
              wx_openid: this.formData.wx_openid || ""
            }
            if (this.create) {
              // 设置时间戳
              const res = await agenjtRegister({ ...data });
              if (res.state === true) {
                that.successMessage(res.message || '客服创建成功');
                // 触发成功事件
                that.$emit('agentDialogCancel', { state: res.state })
              } else {
                throw new Error(res.message || '创建失败，请重试')
              }
            } else {
              const result = await agentUpdate({ ...data });
              if (result.state === true) {
                this.successMessage(result.message);
                that.$emit('agentDialogCancel', { state: result.state })
              }
            }
          } catch (error) {
            that.$message.error(error.message);
          } finally {
            that.submitting = false;
          }
        } else {
          that.$message.warning('请完善表单信息')
        }
      })
    },

    /**
     * 重置表单
     */
    handleReset() {
      this.$refs.categoryForm.resetFields();
      this.create = true;
    },

    /**
     * 取消创建
     */
    handleCancel() {
      this.$confirm('确定取消操作吗？未保存的数据将丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('agentDialogCancel', { state: false })
      }).catch(() => { })
    },

    /**
     * 关闭成功对话框
     */
    handleSuccessDialogClose() {
      this.successDialogVisible = false
      // 重置表单以便继续创建
      this.handleReset()
    }
  }
}
</script>

<style scoped>
.category-create {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.create-card {
  margin-bottom: 20px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.form-buttons {
  margin-top: 30px;
  text-align: center;
}

.success-content {
  text-align: center;
  padding: 20px 0;
}

.success-icon {
  font-size: 48px;
  color: #67C23A;
  margin-bottom: 15px;
}

.success-detail {
  color: #909399;
  font-size: 14px;
  margin-top: 10px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .category-create {
    padding: 10px;
  }

  .create-card {
    margin-bottom: 10px;
  }
}
</style>